<template>
  <VueMultiselect
    v-model="selected"
    :options="filterOptions"
    :multiple="true"
    placeholder="Filter"
    group-values="options"
    group-label="filterType"
    track-by="value"
    label="value"
    :taggable="true"
    :close-on-select="false"
    @select="onFilterToggle"
    @remove="onFilterToggle"
  ></VueMultiselect>
</template>

<script>
import VueMultiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  components: {
    VueMultiselect,
  },
  props: {
    reportStats: {
      type: Object,
      default() {
        return {};
      },
    },
    existingFragmentTypes: {
      type: Object,
      default() {
        return {};
      },
    },
    filterTags: {
      type: Object,
      default() {
        return {
          statuses: [],
          fragmentTypes: [],
        };
      },
    },
  },
  emits: ['filter-toggle'],
  data() {
    return {
      selected: [],
    };
  },
  computed: {
    filterOptions() {
      return [
        {
          filterType: 'Status',
          options: Object.keys(this.reportStats).map((status) => ({
            value: status,
            category: 'statuses',
          })),
        },
        {
          filterType: 'Fragment Type',

          options: [...this.existingFragmentTypes].map((fragmentType) => ({
            value: fragmentType,
            category: 'fragmentTypes',
          })),
        },
      ];
    },
  },
  methods: {
    onFilterToggle({ value, category }) {
      this.$emit('filter-toggle', { value, category });
    },
  },
};
</script>

<style>
.multiselect__tag-icon {
  font-family: 'Open Sans';
}
.multiselect__tag-icon::after {
  font-size: inherit;
}
</style>
